module.exports = __webpack_public_path__ + "img/1504706537.532ad937.jpg";